module.exports = __webpack_public_path__ + "static/media/suber6.713ae835.png";